import * as Scrivito from "scrivito";
import IconComponent from "../../Components/Icon";

function IconWidgetComponent({ widget }) {
  const icon = widget.get("icon");
  const link = widget.get("link");
  const iconSize = `
    is-${widget.get("size") || 300}
    is-md-${widget.get("sizeTablet") || 300}
    is-sm-${widget.get("sizeMobile") || 300}
  `;
  const iconColor = `text-${widget.get("iconColor") || "default"}`;

  if (["center", "right"].includes(widget.get("alignment"))) {
    return (
      <div
        className={`text-${
          widget.get("alignment") === "right" ? "end" : "center"
        }`}
      >
        <IconComponent
          icon={icon}
          size={iconSize}
          link={link}
          color={iconColor}
        />
      </div>
    );
  }

  return (
    <IconComponent icon={icon} size={iconSize} link={link} color={iconColor} />
  );
}

Scrivito.provideComponent("IconWidget", IconWidgetComponent);

export default Scrivito.connect(IconWidgetComponent);
